import { Layout } from 'app/layout/layout.types';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';



// Types
export type Scheme = 'auto' | 'dark' | 'light';
export type Theme = 'default' | string;

/**
 * AppConfig interface. Update this interface to strictly type your config
 * object.
 */
export interface AppConfig
{
    layout: Layout;
    scheme: Scheme;
    theme: Theme;
    providers: any;
}

/**
 * Default configuration for the entire application. This object is used by
 * ZuperConfigService to set the default configuration.
 *
 * If you need to store global configuration for your app, you can use this
 * object to set the defaults. To access, update and reset the config, use
 * ZuperConfigService and its methods.
 */
export const appConfig: AppConfig = {
    layout: 'thin',
    scheme: 'light',
    theme : 'default',
    providers: [
        // ...
        {
          provide: ErrorHandler,
          useValue: Sentry.createErrorHandler(),
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        {
          provide: APP_INITIALIZER,
          useFactory: () => () => {},
          deps: [Sentry.TraceService],
          multi: true,
        },
        provideZoneChangeDetection({ eventCoalescing: true }), 
        importProvidersFrom(TranslateModule.forRoot())
      ]
};
